import { Link } from "react-router-dom";
import { H2, P } from "../components/ui/typography";
import image from "@/assets/apologetic-dog.png";

export function ErrorPage() {
  return (
    <div className="flex h-svh flex-col items-center justify-center text-center">
      <H2>We are sorry</H2>
      <P>We are experiencing some technical difficulties.</P>
      <img src={image} alt="Apologetic dog" className="my-8" height={210} />
      <Link to="/" className="text-axiata-blue underline">
        Go to the home page.
      </Link>
    </div>
  );
}
